module.exports = __webpack_public_path__ + "static/media/battery-testing-red.06cda6bb.svg";